import React from "react";
import { useIntl } from "gatsby-plugin-react-intl";
import Button from "../Button";

import * as S from "./styled";

function BlackBox({ blackBoxType, text1, text2, underlined }) {
  const intl = useIntl();

  return (
    <>
      {(() => {
        switch (blackBoxType) {
          case "custom":
            return (
              <S.BlackBoxWrapper>
                <S.H2>
                  {text1} <span>{underlined}</span> {text2}
                </S.H2>
                <Button>
                  {intl.formatMessage({ id: "buttons.start_here" })}
                </Button>
              </S.BlackBoxWrapper>
            );

          case "talents":
            return (
              <S.BlackBoxWrapper>
                <S.H2>
                  {intl.formatMessage({ id: "talents.black_box.text_1" })}{" "}
                  <span>
                    {intl.formatMessage({ id: "talents.black_box.underlined" })}
                  </span>{" "}
                  {intl.formatMessage({ id: "talents.black_box.text_2" })}
                </S.H2>
                <Button typeButton="scroll-to" goTo="#jobs">
                  {intl.formatMessage({ id: "talents.btn" })}
                </Button>
              </S.BlackBoxWrapper>
            );

          case "start-for-free":
            return (
              <S.BlackBoxWrapper style={{ marginBottom: 0 }}>
                <S.H2 style={{ maxWidth: 630 }}>
                  {intl.formatMessage({ id: "freemium.black_box.text_1" })}{" "}
                  <span>
                    {intl.formatMessage({ id: "freemium.black_box.text_2" })}
                  </span>{" "}
                  {intl.formatMessage({ id: "freemium.black_box.text_3" })}
                </S.H2>
                <Button typeButton="start-for-free" />
              </S.BlackBoxWrapper>
            );

          case "obrigado-teste-gratis":
            return (
              <S.BlackBoxWrapper>
                <div>
                  <S.H2>Ligue para nós sempre que precisar</S.H2>
                  <S.TextTesteGratis>
                    Estamos à disposição para garantir que sua experiência na
                    Axur seja excelente.
                  </S.TextTesteGratis>
                </div>
                <Button typeButton="cta" href="tel:5130122987">
                  (51) 3012-2987
                </Button>
              </S.BlackBoxWrapper>
            );

          default:
            return (
              <S.BlackBoxWrapper>
                <S.H2>
                  {intl.formatMessage({ id: "black_box.text1" })}
                  <span>
                    {" "}
                    {intl.formatMessage({ id: "black_box.underlined" })}{" "}
                  </span>
                  {intl.formatMessage({ id: "black_box.text2" })}
                </S.H2>
                <Button>
                  {intl.formatMessage({ id: "buttons.start_here" })}
                </Button>
              </S.BlackBoxWrapper>
            );
        }
      })()}
    </>
  );
}

export default BlackBox;
